import { defineStore } from 'pinia'

export const useBrandingStore = defineStore('branding', {
    state: () => ({
        brandPrimary: '',
        brandSecondary: '',
        systemError: '',
        systemWarning: '',
        systemSuccess: '',
        black: '',
        logoBigUrl: '',
        logoCompactUrl: '',
    }),
    actions: {
        load(data) {
            this.brandPrimary = data.brandingPrimary;
            this.brandSecondary = data.brandingSecondary;
            this.systemError = data.systemError;
            this.systemWarning = data.systemWarning;
            this.systemSuccess = data.systemSuccess;
            this.black = data.black;
            this.logoBigUrl = data.bigLogo;
            this.logoCompactUrl = data.compactLogo;
        },
    },
})